import React from 'react';
import Navbar from '../HomeComponent/Navbar';
import FooterComponent from '../Footer/FooterComponent';

const TermsOfService = () => {
    return (
        <>
            <Navbar />
            <div style={{ paddingTop: '120px', minHeight: '100vh', background: '#f8fafc', paddingBottom: '80px', fontFamily: "'Inter', sans-serif" }}>
                <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px' }}>

                    {/* Header */}
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <h1 style={{ fontSize: '3rem', fontWeight: '800', color: '#1e293b', marginBottom: '16px', letterSpacing: '-0.02em' }}>
                            Terms of Service
                        </h1>
                        <p style={{ fontSize: '1.125rem', color: '#64748b' }}>
                            Effective Date: {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                        </p>
                    </div>

                    {/* Content Card */}
                    <div style={{ background: 'white', padding: '60px', borderRadius: '24px', boxShadow: '0 10px 40px -10px rgba(0,0,0,0.05)' }}>

                        <div style={{ marginBottom: '40px' }}>
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#475569', marginBottom: '24px' }}>
                                Welcome to ToxBoxAI. By accessing or using our website and services, you agree to be bound by these Terms of Service.
                                Please read them carefully.
                            </p>
                        </div>

                        <Section title="1. Acceptance of Terms">
                            <p>By accessing or using our Services, you verify that you have read, understood, and agree to be bound by these Terms. If you do not agree, you must not access or use our Services.</p>
                        </Section>

                        <Section title="2. Use of Services">
                            <p>You agree to use our Services only for lawful purposes and in accordance with these Terms. You are responsible for all activity that occurs under your account.</p>
                            <ul style={{ listStyleType: 'disc', paddingLeft: '24px', marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                <li>You must not use our Services for any illegal or unauthorized purpose.</li>
                                <li>You agree not to modify, adapt, or hack the Services.</li>
                                <li>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Services.</li>
                            </ul>
                        </Section>

                        <Section title="3. Intellectual Property">
                            <p>The Service and its original content, features, and functionality are and will remain the exclusive property of ToxBoxAI and its licensors. The Service is protected by copyright, trademark, and other laws.</p>
                        </Section>

                        <Section title="4. Termination">
                            <p>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
                        </Section>

                        <Section title="5. Changes to Terms">
                            <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.</p>
                        </Section>

                        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '30px', marginTop: '40px' }}>
                            <p style={{ fontSize: '0.95rem', color: '#94a3b8', fontStyle: 'italic' }}>
                                * These terms govern the relationship between you and ToxBoxAI.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
            <FooterComponent />
        </>
    );
};

const Section = ({ title, children }) => (
    <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#0f172a', marginBottom: '16px' }}>{title}</h2>
        <div style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#475569' }}>
            {children}
        </div>
    </section>
);

export default TermsOfService;
